import FetchFactory from '../factory'

class LandingPageModule extends FetchFactory<any> {
    // async getLpHeader() {
    //     return await useAsyncData(() => {
    //         return super.call(`/api/lp/content/company_lp_hero-section`, {
    //             method: 'GET'
    //         })
    //     })
    // }

    async getSeo() {
        return await useAsyncData(() => {
            return super.call('/api/lp/content/seo_lp_job-seeker', {
                method: 'GET',
      })
        })
    }

    async getLpBenefit() {
        return await useAsyncData(() => {
            return super.call('/api/lp/content/jobseeker_lp_why-samurai', {
                method: 'GET',
      })
        })
    }

    async getFeaturedJobCategories() {
        return await useAsyncData(() => {
            return super.call('/api/lp/featured-job-categories', {
                method: 'GET',
      })
        })
    }

    async getTrendingJobs() {
        return await useAsyncData(() => {
            return super.call('/api/lp/trending-job-sectors', {
                method: 'GET',
      })
        })
    }

    async getLpTrendingJobsTitle() {
        return await useAsyncData(() => {
            return super.call('/api/lp/content/jobseeker_lp_trending-job', {
                method: 'GET',
      })
        })
    }

    async getLpRecentJobsTitle() {
        return await useAsyncData(() => {
            return super.call('/api/lp/content/jobseeker_lp_recent-job', {
                method: 'GET',
      })
        })
    }

    async getRecentJobs() {
        return await useAsyncData(() => {
            return super.call('/api/lp/recent-jobs', {
                method: 'GET',
      })
        })
    }

    async getLpFeaturedJobsTitle() {
        return await useAsyncData(() => {
            return super.call('/api/lp/content/jobseeker_lp_featured-jobs', {
                method: 'GET',
      })
        })
    }

    async getFeaturedJobs() {
        return await useAsyncData(() => {
            return super.call('/api/lp/featured-jobs', {
                method: 'GET',
      })
        })
    }

    async getLpCustomerReview() {
        return await useAsyncData(() => {
            return super.call('/api/lp/content/jobseeker_lp_customer-review', {
                method: 'GET',
      })
        })
    }

    async getLpCustomerReviewNew() {
        return await useAsyncData(() => {
            return super.call('/api/lp/testimonials', {
                method: 'GET',
                query: {
                    'filter[type]': 'job_seeker',
                }
            })
        })
    }

    async getLpTrustedCompanies() {
        return await useAsyncData(() => {
            return super.call(
        '/api/lp/content/jobseeker_lp_trusted-by-top-companies',
        {
                    method: 'GET',
        }
            )
        })
    }

    async getLpTrustedCompaniesNew() {
        return await useAsyncData(() => {
            return super.call(
        '/api/lp/trusted-by-companies',
        {
                    method: 'GET',
        }
            )
        })
    }

    async getLpCta() {
        return await useAsyncData(() => {
            return super.call('/api/lp/content/jobseeker_lp_cta', {
                method: 'GET',
      })
        })
    }

    async getPrivacyPolicy() {
        return await useAsyncData(() => {
            return super.call(
        '/api/lp/content/legal_policy_privacy-and-policy',
        {
                    method: 'GET',
        }
            )
        })
    }

    async getTermsAndConditions() {
        return await useAsyncData(() => {
            return super.call(
        '/api/lp/content/legal_policy_terms-and-condition',
        {
                    method: 'GET',
        }
            )
        })
    }

    async getSuggestions() {
        return await useAsyncData(() => {
            return super.call('/api/lp/suggestions', {
                method: 'GET',
      })
        })
    }

    async getHero() {
        return await useAsyncData(() => {
            return super.call('/api/lp/content/jobseeker_lp_hero', {
                method: 'GET',
      })
        })
    }
}

export default LandingPageModule
